import { Content } from '../../types';

export const saPaContent: Content = {
  title: 'סאפה',
  imageUrl: '/images/vietnam/sa-pa/sa-pa-wide.jpeg',
  introduction:
    'העיירה סאפה הינה עיירה הררית בעלת יופי טבעי מרהיב בצפון - מערב וייטנאם, כ-400 קילומטרים מערבית להאנוי. העיירה מוקפת רכס הררי גבוה מאוד, כאשר הר הפאנסיפאן, שאליו ניתן להגיע באמצעות טרקים ו/או רכבל, מהווה את הפסגה הגבוהה ביותר באזור ובוייטנאם כולה.\nהעיירה עצמה מתאפיינת בפיתוח תיירותי נרחב. בין ההרים הגבוהים שוכנים כפרים המאוכלסים על ידי מספר שבטים אתניים, שעיקר עיסוקם הוא גידול אורז בשדות ובטרסות הציוריות המרהיבות המקיפות את הכפר. במקום אף התפתח ענף תיירותי קסום של טיולים במרחב ואירוח ביתי על ידי נשות השבטים (המאמות).',
  sections: [
    {
      title: 'דרכי הגעה',
      type: 'text',
      content:
        'הדרך הנוחה ע"מ להגיע לעיירה הינה באמצעות אוטובוסי סליפר וואן לימוזין מהאנוי (בתקופות מסוימות אף מהא ג\'יאנג), או ברכבת היוצאת מהאנוי לתחנת Lao Cai ומשם נסיעה נוספת של כשעה.',
    },
    {
      title: 'מתי להגיע?',
      type: 'text',
      content:
        'ניתן לטייל באזור במהלך כל השנה, אך יש לקחת בחשבון כי טרסות האורז נראות במלוא יופיין במהלך העונה הגשומה (יוני עד אוקטובר) ואילו בין החודשים דצמבר לפברואר מזג האוויר עשוי להיות ערפילי ואף קפוא ולא יאפשר הנאה מלאה מהנופים המיוחדים.',
    },
    {
      title: 'אטרקציות מרכזיות בסאפה ובסביבתה',
      type: 'list',
      content: [
        {
          subtitle: 'הר הפאנסיפאן (Fansipan)',
          text: 'ההר הגבוה ביותר בוייטנאם, בגובה 3,143 מטרים. ניתן להעפיל לפסגה באמצעות טרק מאתגר של יומיים או לקחת רכבל מודרני המוביל לפסגה תוך 15 דקות, עם נופים עוצרי נשימה של האזור ההררי.',
        },
        {
          subtitle: 'טרסות האורז של סאפה',
          text: 'השדות המפורסמים המקיפים את הכפרים ההרריים. הטרסות מציעות נופים ציוריים מרהיבים ומשתנות בהתאם לעונה - ירוקות ושופעות בקיץ, מוזהבות בסתיו וכסופות לאחר הקציר.',
        },
        {
          subtitle: 'כפרי השבטים המקומיים',
          text: "באזור סאפה ישנם כפרים רבים המאוכלסים על ידי קבוצות אתניות שונות, כל אחת עם מסורותיה הייחודיות:\nכפר קאט קאט (Cat Cat) - אחד הכפרים הקרובים ביותר לעיירה, עם מסורת עשירה של אריגה ומלאכות יד.\nכפר טא ואן (Ta Van) - ביתם של בני שבט הזאי, מציע חוויות אירוח ביתי ולינה אותנטית.\nכפר לאו צ'אי (Lao Chai) - כפר יפהפה המאוכלס על ידי בני שבט המונג השחור.\nכפר טא פין (Ta Phin) - ביתם של שבט דאו האדום, המפורסמים בטיפולי הצמחים שלהם, במיוחד אמבטיות הצמחים המסורתיות.",
        },
        {
          subtitle: 'עמק מונג הואה (Muong Hoa Valley)',
          text: 'עמק עוצר נשימה המשתרע בין סאפה לכפר טא ואן. בעמק ניתן לראות טרסות אורז ציוריות, נהרות צלולים ואבנים חקוקות בסמלים מסתוריים.',
        },
        {
          subtitle: "המפל הכסוף (Silver Waterfall) ומעבר הואהו (Heaven's Gate)",
          text: 'מפל בגובה של כ-200 מטרים הממוקם כ-12 ק"מ מסאפה. ניתן להמשיך ממנו למעבר ההרים הואהו (Cổng Trời) בגובה 2,000 מטרים, עם תצפית מדהימה על רכסי ההרים.',
        },
        {
          subtitle: 'מפל האהבה (Love Waterfall) והעץ הבודד',
          text: 'מפל רומנטי ויפהפה הנמצא כ-14 ק"מ מסאפה, מוקף ביער ירוק ושופע, המספק אווירה קסומה למבקרים. בקרבת המפל נמצא העץ הבודד, עץ מרשים העומד לבדו בנוף הפתוח ומהווה נקודת צילום פופולרית ומיוחדת.',
        },
        {
          subtitle: 'שווקי סוף השבוע בסאפה ובלאו קאי',
          text: 'שוק באק הא (Bac Ha Market) - שוק צבעוני המתקיים בימי ראשון, בו שבטים שונים מגיעים לסחור בבעלי חיים, בגדים, פירות ועוד.\nשוק קאן קאאו (Can Cau Market) - שוק אותנטי יותר המתקיים בימי שבת עם אווירה מקומית.',
        },
        {
          subtitle: 'אגם סאפה וכיכר העיר',
          text: 'בלב העיירה נמצא האגם הפסטורלי עם מסלולי הליכה נעימים, מוקף במסעדות ובתי קפה. לידו נמצאת כיכר העיר וכנסיית האבן המפורסמת של סאפה.',
        },
        {
          subtitle: 'טיולים והרפתקאות באזור',
          text: 'טרקים מודרכים באזור הכפרים והעמקים - חוויות בלתי נשכחות בין טרסות האורז והכפרים האותנטיים.\nרכיבה על אופניים בעמק מונג הואה - דרך מושלמת לחקור את הנוף ההררי המרהיב.\nאמבטיות צמחים בכפר טא פין - חוויית רוגע וטיפול מסורתי מדהים.',
        },
      ],
    },
    {
      title: 'סיכום',
      type: 'text',
      content:
        'בשורה התחתונה, סאפה הינה יעד המשלב טבע מרהיב, תרבות מסורתית ייחודית וחוויות בלתי נשכחות, מה שהופך אותה לאחת הפנינות היפות של וייטנאם.',
    },
  ],
};
